<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="default-page-width">
                <div class="card card-default">
                    <div class="card-header">{{$t('marketing-equipment.' + mode)}}</div>
                    <div class="card-body">
                        <ValidationObserver v-slot="{ invalid }">
                        <form role="form">
                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.type')}} *</label>

                                <div class="col-md-6">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <kendo-dropdownlist ref="fieldconfig"
                                                            :data-items="fieldsDefinitionsDatasource"
                                                            :text-field="'name'"
                                                            :data-item-key="'id'"
                                                            :value-field="'id'"
                                                            :value-primitive="true"
                                                            :value="form.fieldsDefinitionId"
                                                            class="fieldsDefinitionDropDown"
                                                            :default-item="placeholders.fieldsDefinitionsPlaceholderItem"
                                                            @change="onFieldSetDefinitionSelect"
                                        >
                                        </kendo-dropdownlist>
                                        <span>{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.number')}} *</label>

                                <div class="col-md-6">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <input ref="firstInput" type="text" class="form-control" v-model="form.number">
                                        <span>{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.inventorynumber')}}</label>

                                <div class="col-md-6">
                                    <input ref="inventoryNumber" type="text" class="form-control" v-model="form.inventory_number">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.name')}} *</label>

                                <div class="col-md-6">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <input ref="firstInput" type="text" class="form-control" v-model="form.name">
                                        <span>{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.desc')}}</label>

                                <div class="col-md-6">
                                    <input type="text" class="form-control" v-model="form.desc">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.category')}} *</label>

                                <div class="col-md-6">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <kendo-dropdownlist ref="categoryId"
                                                           :data-items="categoryDatasource"
                                                           :text-field="'text'"
                                                           :value-field="'id'"
                                                           :data-item-key="'id'"
                                                           :value-primitive="true"
                                                           v-model="form.categoryId"
                                                           class="fieldsDefinitionDropDown"
                                                           :default-item="placeholders.categoryPlaceholderItem">
                                        </kendo-dropdownlist>
                                        <span>{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.condition')}}</label>

                                <div class="col-md-6">
                                    <input type="text" class="form-control" v-model="form.condition">
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.tags')}}</label>

                                <div class="col-md-6">
                                    <kendo-multiselect ref="tagbox"
                                                       :data-items="tagDatasource"
                                                       :text-field="'text'"
                                                       :allow-custom="true"
                                                       :value-field="'value'"
                                                       :data-item-key="'id'"
                                                       :filterable="true"
                                                       :placeholder="$t('general.please_choose_tags')"
                                                       v-model="form.tags"
                                                       @filterchange="onTagboxFilterChange">
                                    </kendo-multiselect>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.images')}}</label>

                                <div class="col-md-6">
                                    <rms-objects-uploads
                                        :mode="mode"
                                        :imageFiles="form.images"
                                        @imageFilesChanged = "onImageFilesChanged"
                                    >
                                    </rms-objects-uploads>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.location')}} *</label>

                                <div class="col-md-6">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <kendo-dropdownlist ref="locationId"
                                                            :data-items="locationDatasource"
                                                            :text-field="'text'"
                                                            :value-field="'id'"
                                                            :data-item-key="'id'"
                                                            :value-primitive="true"
                                                            v-model="form.locationId"
                                                            class="fieldsDefinitionDropDown"
                                                            :default-item="placeholders.locationPlaceholderItem">
                                        </kendo-dropdownlist>
                                        <span>{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.availability')}} *</label>

                                <div class="col-md-6">
                                    <ValidationProvider rules="required" v-slot="{ errors }">
                                        <kendo-dropdownlist ref="availabilityId"
                                                            :data-items="availabilityvaluesDatasource"
                                                            :text-field="'text'"
                                                            :value-field="'id'"
                                                            :data-item-key="'id'"
                                                            :value-primitive="true"
                                                            v-model="form.availabilityId"
                                                            class="fieldsDefinitionDropDown"
                                                            :default-item="placeholders.availabilityPlaceholderItem">
                                        </kendo-dropdownlist>
                                        <span>{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.available-for-rent')}}</label>

                                <div class="col-md-6">
                                    <kendo-switch v-model="form.requestable" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.archived')}}</label>

                                <div class="col-md-6">
                                    <kendo-switch v-model="form.archived" />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.notes')}}</label>

                                <div class="col-md-6">
                                    <kendo-editor ref="noteField"
                                                  :resizable="true"
                                                  :tools="editor.editorTools"
                                                  :default-content="form.note"
                                                  :paste-html="onEditorPasteHtml"
                                                  :content-style="{
                                                    height: '430px',
                                                  }">
                                    </kendo-editor>
                                </div>
                            </div>

                            <div class="form-group row" v-if="convertedFields">
                                <label class="col-md-4 col-form-label text-md-right">{{$t('objects.form.additional-fields')}}</label>

                                <div class="col-md-6">
                                    <vue-form-generator
                                            :schema="convertedFields"
                                            :model="fieldsDefinitionFilledData"
                                            :options="formOptions"></vue-form-generator>
                                </div>
                            </div>

                            <div class="form-group row mb-0">
                                <div class="col-md-6 offset-md-4">
                                    <button type="submit" class="btn btn-secondary" v-if="mode == 'create' || mode == 'edit' || mode == 'display'"
                                            @click.prevent="handleBack('objects-grid', true, {reload: false, id: rmsobjectid})">
                                        {{ $t('buttons.back-abort') }}
                                    </button>
                                    <button :disabled="invalid" type="submit" class="btn btn-success" v-if="mode == 'create'"
                                            v-shortkey.once="['ctrl', 's']" @shortkey="createObject"
                                            @click.prevent="createObject">
                                        {{ $t('buttons.create') }}
                                    </button>
                                    <button :disabled="invalid" type="submit" class="btn btn-success" v-if="mode == 'edit'"
                                            v-shortkey.once="['ctrl', 's']" @shortkey="editObject"
                                            @click.prevent="editObject">
                                        {{ $t('buttons.save') }}
                                    </button>
                                </div>
                            </div>
                        </form>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import rmsObjectsUploads from "./rms-objects-uploads";

    import { EditorUtils } from "@progress/kendo-vue-editor";
    import { filterBy } from '@progress/kendo-data-query';
    import {$t} from "../../i18Instance";

    export default {
        name: "form-rms-object",
        props: {
            mode: {
                type: String,
                default: 'create'
            },
            user: {
                type: String
            },
            rmsobjectid: {
                type: Number
            },
            formdisabled: {
                type: Boolean,
                default: false
            }
        },
        components:{
            rmsObjectsUploads
        },
        data: function () {
            return {
                fieldsDefinitionsDatasource: [],
                categoryDatasource: [],
                tagDatasource: [],
                tagDatasourceUnfiltered: [],
                locationDatasource: [],
                availabilityvaluesDatasource: [],

                loadedData: false,
                blankItem: {
                    id: null,
                    name: this.$t('general.please_choose')
                },
                form:{
                    fieldsDefinitionId: null,
                    categoryId: null,
                    locationId: null,
                    availabilityId: null,
                    requestable: false,
                    archived: false,
                    note: "",
                    mainImage: null,
                    tags: null,
                    image: {}
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAsync: true,
                    validateAfterChanged: true,
                    validationErrorClass: "error",
                    validationSuccessClass: ""
                },
                fieldsDefinition:{
                    field_type: null,
                },
                fieldsDefinitionFilledData: {},
                convertedFields:null,


                editor:{
                    editorTools: [
                        "FormatBlock",
                        "FontSize",
                        "FontName",
                        ["Bold", "Italic", "Underline", "Strikethrough"],
                        ["AlignLeft", "AlignCenter", "AlignRight"],
                        ["Indent", "Outdent"],
                        ["OrderedList", "UnorderedList"],
                        ["Undo", "Redo"],
                        ["Link", "Unlink", "InsertImage"],
                    ],
                },

                placeholders:{
                    fieldsDefinitionsPlaceholderItem:{
                        name: this.$t('general.please_choose')
                    },
                    categoryPlaceholderItem: {
                        text: this.$t('objects.form.please_choose_category')
                    },
                    locationPlaceholderItem: {
                        text: this.$t('objects.form.please_choose_location')
                    },
                    availabilityPlaceholderItem: {
                        text: this.$t('objects.form.please_choose_availability')
                    }

                }

            }
        },
        mounted() {
            this.init();
        },
        methods: {
            onImageFilesChanged(changedMedia){
                this.form.imageFiles = changedMedia;
            },

            // Alternative Methode, um einen Tag durch "Return" hinzuzufügen"
            init(){
                //let widget = this.$refs['tagbox'].kendoWidget();
                //widget.input.on('keydown', this.onTagboxKeyPress);


                // Laden der Felddefinitionen
                axios
                    .get('/api/rmsobjects/fieldsdefinitions')
                    .then(response => {
                        this.fieldsDefinitionsDatasource = response.data;
                    });

                // Laden der Kategorien
                axios
                    .get('/api/rmsobjects/categories')
                    .then(response => {
                        this.categoryDatasource = response.data;
                    });

                // Laden der Tags
                axios
                    .get('/api/rmsobjects/tags')
                    .then(response => {
                        this.tagDatasource = response.data;
                        this.tagDatasourceUnfiltered = response.data;
                    });

                // Laden der Standorte
                axios
                    .get('/api/rmsobjects/locations')
                    .then(response => {
                        this.locationDatasource = response.data;
                    });

                // Laden der Verfügbarkeiten
                axios
                    .get('/api/rmsobjects/availabilityvalues')
                    .then(response => {
                        this.availabilityvaluesDatasource = response.data;
                    });

                // Laden eines bestehenden Objektes
                if(this.rmsobjectid){
                        this.mode = "edit";
                    axios
                        .get('/api/rmsobjects/id/' + this.rmsobjectid)
                        .then(response => {
                            console.log("got data", response);
                            this.loadedData = response.data;
                            this.prepareEditData();
                        })
                        .catch(error => {
                            console.log("err", error);
                        })
                        .finally(() => {})
                }else{
                    this.mode = "create";
                }



            },

            /**
             * Bereitet die geladenen Daten für die Edit-Maske vor
             */
            prepareEditData: function() {
                console.log("prepareEditData");
                // Formulardaten setzen
                //console.log(this.loadedData);
                this.form.id = this.loadedData.id;
                this.form.fieldsDefinitionId = this.loadedData.field_set_definition_id;
                this.form.number = this.loadedData.number;
                this.form.inventory_number = this.loadedData.inventory_number;
                this.form.name = this.loadedData.name;
                this.form.desc = this.loadedData.desc;
                this.form.categoryId = this.loadedData.category_id;
                this.form.condition = this.loadedData.condition;
                this.form.tags = this.loadedData.attachedTags;
                this.form.images =this.loadedData.images;
                this.form.locationId = this.loadedData.location_id;
                this.form.availabilityId = this.loadedData.availability_id;
                this.form.requestable = this.loadedData.requestable;
                if(this.loadedData['archived_at'] && this.loadedData['archived_at'] != 'null' && this.loadedData['archived_at'] != undefined){
                    this.form.archived = true;
                }else{
                    this.form.archived = false;
                }
                if(this.loadedData.note){
                    this.$refs['noteField'].setHTML(this.loadedData.note);
                }


                // Zusätzliche Felder
                this.loadFieldSetDefinition(null, this.form.fieldsDefinitionId);
                this.fieldsDefinitionFilledData = this.loadedData.form_data;
                if(null == this.fieldsDefinitionFilledData || this.fieldsDefinitionFilledData.length == 0){
                    this.fieldsDefinitionFilledData = {};
                }
            },

            // region FieldsetDefinitions

            /**
             * Eventhandler wird ausgelöst, wenn die Auswahl der Formularfelddefinition geändert wurde
             * @param e
             */
            onFieldSetDefinitionSelect(e){
                console.log("changed selection: ", e.value);
                console.log("old value: ", this.form.fieldsDefinitionId);
                // Standarfverhalten auf jeden Fall abbrechen und manuell die Werte setzen
                //e.preventDefault();
                //this.confirmSelectionChange(e, e.dataItem.id, e.sender.value());
                this.confirmSelectionChange(e, e.value, this.form.fieldsDefinitionId);
            },

            /**
             * Bestätigt die
             * @param e
             */
            confirmSelectionChange(e, definitionId, oldId){
                console.log("select", e, definitionId, oldId);
                if(!_.isEmpty(this.fieldsDefinitionFilledData) && (this.form.fieldsDefinitionId != definitionId || definitionId <= 0)){
                    // Wenn wieder auf "Bitte wählen" geschaltet wird Daten zurücksetzen. (ggf. Warnung)
                    swal.fire({
                        title: this.$t('objects.form.additional-fields-exit-header'),
                        text: this.$t('objects.form.additional-fields-exit-text'),
                        icon: "warning",
                        showCancelButton: true,
                        cancelButtonText: this.$t('general.cancel'),
                        confirmButtonText: this.$t('general.ok')
                    }).then((willDelete) => {
                            if (willDelete.value) {
                                // Felddefinition wechseln
                                this.fieldsDefinitionFilledData = {};
                                this.convertedFields=null;
                                this.loadFieldSetDefinition(e, definitionId);
                            } else {
                                return;
                            }
                        });
                }else{
                    console.log("normales laden der Felddefinition");
                    this.convertedFields=null;
                    this.form.fieldsDefinitionId = definitionId;
                    this.loadFieldSetDefinition(e, definitionId);
                }
            },

            /**
             * Lädt die Formularfelddefinition
             * @param definitionId
             */
            loadFieldSetDefinition(e, definitionId){
                console.log("loadfieldsetdefinition?", e, definitionId);
                this.form.fieldsDefinitionId = definitionId;
                if(definitionId !== "" && definitionId !== null && definitionId !== undefined){
                    axios.get('/api/rmsobjects/fieldsdefinitions/id/' + definitionId)
                        .then(response => {
                            console.log("loadfieldsetdefinition response", response);
                            this.fieldsDefinition = response.data;
                            this.buildForm(this.fieldsDefinition);
                        });
                }
            },

            /**
             * Baut das Formular unter Verwendung der übergebenen Felddefinition auf
             * @param fieldsDefinition Formularfelddefinition
             */
            buildForm(fieldsDefinition){
                console.log("building form");
                let tmpArr = {fields:[]};
                fieldsDefinition.field_type.map(function(value, key) {
                    if(value.configuration.label){
                        value.configuration.label = $t('cstrings.colfields.' + value.configuration.label);
                    }
                    if(value.configuration.placeholder){
                        value.configuration.placeholder = $t('cstrings.colfields.' + value.configuration.placeholder);
                    }
                    if(value.configuration.hint){
                        value.configuration.hint = $t('cstrings.colfields.' + value.configuration.hint);
                    }

                    tmpArr.fields.push(value.configuration)
                });
                this.convertedFields = tmpArr;
            },

            //endregion


            // region Tag-Box

            onTagboxFilterChange(e){
                this.tagDatasource = filterBy(this.tagDatasourceUnfiltered.slice(), e.filter);
            },
            /**
             * Fügt durch Enter-Tastendruck einen neuen Tag hinzu
             * @param e
             */
            onTagboxKeyPress(e) {
                if (e.key !== "Enter") {
                    return;
                }
                e.preventDefault();

                let widget = this.$refs['tagbox'].kendoWidget();
                let newValue = widget.input.val();
                if(newValue.length > 0){
                    widget.dataSource.add({
                        text: newValue,
                        value: newValue
                    });

                    // Workaround für Kendo Bug
                    setTimeout(function(){
                        widget.value(widget.value().concat([newValue]));
                    }, 1);
                }
            },

            onEditorPasteHtml(e) {
                let html = pasteCleanup(sanitize(e.pastedHtml), pasteSettings);
                if (e.event.clipboardData) {
                    html = replaceImageSourcesFromRtf(html, e.event.clipboardData);
                }
                return html;
            },

            //endregion

            resetForm(){
                this.form = {};
            },

            onWindowActivated(){
                this.$refs.firstInput.focus();
            },

            onWindowClosed:function(){
                this.resetForm();
            },

            /**
             * Bereitet Daten zum senden vor
             */
            prepareData(){
                this.form.customFields = this.fieldsDefinitionFilledData;
                this.form.note = this.$refs['noteField'].getHTML();

                console.log(this.form);
            },

            createObject() {
                this.prepareData();
                this.sendForm('post','/api/rmsobjects', this.form)
                    .then(() => {
                        console.log("angelegt");
                        this.resetForm();
                        this.$emit('rms-object-created');
                        //this.hideWindow();
                        swal.fire({
                            title: "Equipment angelegt",
                            text: "Der Datensatz wurde angelegt, Sie werden zur Übersicht weitergeleitet",
                            icon: "success",
                            timer: 1000
                        }).then(() => {
                            this.handleBack('objects-grid', true, {reload: true});
                        });
                    });
            },


            editObject(){
                this.prepareData();
                this.sendForm('put','/api/rmsobjects/update/'+this.form.id, this.form)
                    .then(() => {
                        this.$emit('rms-object-updated');
                        swal.fire({
                            title: "Equipment aktualisiert",
                            text: "Der Datensatz wurde aktualisiert, Sie werden zur Übersicht weitergeleitet",
                            icon: "success",
                            timer: 1000
                        }).then(() => {
                            this.handleBack('objects-grid', true, {reload: true, id: this.form.id});
                        });
                    });
            },

            onSaveFile:function(e){
                console.log("onSaveFile",e);
                var xhr = e.XMLHttpRequest;
                console.log("xhr",xhr);
                if (xhr) {
                    xhr.addEventListener("readystatechange", function (e) {
                        if (xhr.readyState == 1 /* OPENED */) {
                            xhr.setRequestHeader("X-CSRF-TOKEN", $('meta[name="csrf-token"]').attr('content'));
                            xhr.setRequestHeader("X-XSRF-TOKEN", $('meta[name="xsrf-token"]').attr('content'));
                        }
                    });
                }
            },

            onSaveFileSuccess:function(e){
                console.log("Save File success:",e);
                if(e.response.error == 0){
                    this.form.tmpFile = e.response;
                }
            },

            onSaveFileComplete:function(e){
                console.log("Save File complete:",e);
            },

            onSaveFileError:function(e){
                console.log("Save File Error:",e);
            },

            sendForm(method, uri, form){
                return new Promise((resolve, reject) => {
                    axios[method](uri, JSON.parse(JSON.stringify(form)))
                        .then(response => {
                            resolve(response.data);
                        })
                        .catch(errors => {
                            reject(errors.response.data);
                        });
                });
            }
        }
    }
</script>

<style scoped>
</style>
